/** El módulo no se muestra si no hay al menos 3 vídeos válidos. */
export const MIN_VIDEOS = 3

/** A partir de cuántos vídeos válidos se asoman 2 tarjetas a cada lado de la
 * activa (en vez de 1) — ver `resolveMaxPeek`. */
export const PEEK_THRESHOLD = 5

/** Tarjetas que asoman a cada lado de la activa cuando hay `PEEK_THRESHOLD`
 * o más vídeos válidos. */
export const MAX_PEEK_LARGE = 2

/** Tarjetas que asoman a cada lado de la activa cuando hay entre
 * `MIN_VIDEOS` y `PEEK_THRESHOLD - 1` vídeos válidos. */
export const MAX_PEEK_SMALL = 1

/** Etiqueta accesible del módulo. */
export const SECTION_LABEL = 'Vídeos'
